// This file is auto-generated by @hey-api/openapi-ts

import type {
  CalculateSavedPaymentAccountTransactionsResponse,
  GetTransactionDetailsResponse,
  GetTransactionsResponse,
  GetTransferExchangeRateResponse,
  GetWithdrawalRequestStatusResponse,
  SaveWithdrawalRequestResponse,
} from "./types.gen";

const cashierTransactionViewSchemaResponseTransformer = (data: any) => {
  data.created_at = new Date(data.created_at);
  return data;
};

export const getTransactionsResponseTransformer = async (
  data: any
): Promise<GetTransactionsResponse> => {
  data = data.map((item: any) =>
    cashierTransactionViewSchemaResponseTransformer(item)
  );
  return data;
};

const cashierTransactionTimelineStepSchemaResponseTransformer = (data: any) => {
  if (data.timestamp) {
    data.timestamp = new Date(data.timestamp);
  }
  return data;
};

const cashierTransactionViewDetailsSchemaResponseTransformer = (data: any) => {
  data = cashierTransactionViewSchemaResponseTransformer(data);
  data.timeline = data.timeline.map((item: any) =>
    cashierTransactionTimelineStepSchemaResponseTransformer(item)
  );
  return data;
};

export const getTransactionDetailsResponseTransformer = async (
  data: any
): Promise<GetTransactionDetailsResponse> => {
  data = cashierTransactionViewDetailsSchemaResponseTransformer(data);
  return data;
};

const transferExchangeRateResponseSchemaResponseTransformer = (data: any) => {
  data.expiration_timestamp = new Date(data.expiration_timestamp);
  return data;
};

export const getTransferExchangeRateResponseTransformer = async (
  data: any
): Promise<GetTransferExchangeRateResponse> => {
  data = transferExchangeRateResponseSchemaResponseTransformer(data);
  return data;
};

const withdrawalRequestCreatedSchemaResponseTransformer = (data: any) => {
  data.created_at = new Date(data.created_at);
  return data;
};

export const saveWithdrawalRequestResponseTransformer = async (
  data: any
): Promise<SaveWithdrawalRequestResponse> => {
  data = withdrawalRequestCreatedSchemaResponseTransformer(data);
  return data;
};

const withdrawalRequestStatusSchemaResponseTransformer = (data: any) => {
  data.created_at = new Date(data.created_at);
  return data;
};

export const getWithdrawalRequestStatusResponseTransformer = async (
  data: any
): Promise<GetWithdrawalRequestStatusResponse> => {
  data = withdrawalRequestStatusSchemaResponseTransformer(data);
  return data;
};

const calculatedTransactionsSchemaResponseTransformer = (data: any) => {
  if (data.exchange_rate_valid_until) {
    data.exchange_rate_valid_until = new Date(data.exchange_rate_valid_until);
  }
  return data;
};

export const calculateSavedPaymentAccountTransactionsResponseTransformer =
  async (
    data: any
  ): Promise<CalculateSavedPaymentAccountTransactionsResponse> => {
    data = calculatedTransactionsSchemaResponseTransformer(data);
    return data;
  };
